<template>
    <div class="oa-nav">
        <div class="logo">法律服务在线互动</div>
        <div class="nav">
            <router-link tag="div" v-if="currUserInfo.role==3" to="/advisorynotes">咨询须知</router-link>
            <router-link tag="div" v-if="currUserInfo.role==3||currUserInfo.role==2" to="/casereference">案例参考</router-link>
            <router-link tag="div" v-if="currUserInfo.role==3" to="/areplyselection">回复选登</router-link>
            <router-link tag="div" v-if="currUserInfo.role==3" to="/consultationnow">现在咨询</router-link>
            <router-link tag="div" v-if="currUserInfo.role==3" to="/myconsultation">我的咨询</router-link>
            <router-link tag="div" v-if="currUserInfo.role==3" to="/expertintroduction">专家介绍</router-link>
            <router-link tag="div" v-if="currUserInfo.role==3" to="/contactprovincialunion">联系省工商联</router-link>
            <router-link tag="div" v-if="currUserInfo.role==2" to="/informationlist">咨询列表</router-link>
            <router-link tag="div" v-if="currUserInfo.role==2" to="/myanswer">我的回答</router-link>
            <router-link tag="div" v-if="currUserInfo.role==2" to="/answerrank">回答排名</router-link>
            <router-link tag="div" v-if="currUserInfo.role==2" to="/landrdatabase">法律法规数据库</router-link>
            <router-link tag="div" v-if="currUserInfo.role==1" to="/usermanager">用户管理</router-link>
            <router-link tag="div" v-if="currUserInfo.role==1" to="/consultationmanager">咨询管理</router-link>
        </div>
        <div class="userinfo" v-text="currUserInfo.nickname"></div>
        <div class="logout" @click="logout">退出</div>
    </div>
</template>
<script>
export default {
    name: "oaNav",
    data() {
        return {
            currUserInfo:{}//当前用户的信息
        };
    },
    mounted(){
        this.getCurrUser();
    },
    methods: {
        logout() {
            this.$http.post("/user/loginOut").then(res => {
                if (res.status == 0) {
                    this.$router.push({
                        name: "login"
                    });
                } else {
                    this.$alert.init({
                        type: "error",
                        content: res.content
                    });
                }
            });
        },
        //获取当前用户的接口 初始化用户用
        getCurrUser() {
            this.$http.post("/user/currentUser").then(res => {
                if (res) {
                    this.currUserInfo = res;
                }
            });
        },
    }
};
</script>
<style lang="less" scoped="scoped">
.oa-nav {
    display: flex;
    color: #f5f5f5;
    height: 60px;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    .logo {
        width: 20%;
        text-align: center;
        font-size: 24px;
    }
    .nav {
        width: 70%;
        height: 60px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        div {
            cursor: pointer;
            padding: 0px 10px;
        }
    }
    .userinfo{
        width: 5%;
    }
    .logout{
        width: 5%;
    }
    .router-link-active {
        color: #42b983;
    }
    .logout {
        cursor: pointer;
        &:hover {
            color: #42b983;
        }
    }
}
</style>
